import { defineMessages } from 'react-intl';

export const communityTemplatesMessages = defineMessages({
  registrySelectorTitle: {
    id: 'communityTemplates.registrySelectorTitle',
    defaultMessage: 'Import from Community',
  },
  registrySelectorSearchPlaceholder: {
    id: 'communityTemplates.registrySelectorSearchPlaceholder',
    defaultMessage: 'Search by name or description…',
  },
  registrySelectorEmpty: {
    id: 'communityTemplates.registrySelectorEmpty',
    defaultMessage: 'No community templates found',
  },
  registrySelectorImporting: {
    id: 'communityTemplates.registrySelectorImporting',
    defaultMessage: 'Importing…',
  },
  registrySelectorUnsupportedFamily: {
    id: 'communityTemplates.registrySelectorUnsupportedFamily',
    defaultMessage: 'Community catalog is not available for this asset type',
  },
  importSuccess: {
    id: 'communityTemplates.importSuccess',
    defaultMessage: 'Template imported',
  },
  importError: {
    id: 'communityTemplates.importError',
    defaultMessage: 'Failed to import template',
  },
});

export const publishTemplateMessages = defineMessages({
  publishTitle: {
    id: 'publishTemplate.title',
    defaultMessage: 'Publish to Community',
  },
  publishDescription: {
    id: 'publishTemplate.description',
    defaultMessage:
      'Share "{name}" with other organizations. A snapshot of the current version will be published.',
  },
  descriptionPlaceholder: {
    id: 'publishTemplate.descriptionPlaceholder',
    defaultMessage: 'Describe what this template is for and when to use it...',
  },
  specialty: {
    id: 'publishTemplate.specialty',
    defaultMessage: 'Specialty',
  },
  category: {
    id: 'publishTemplate.category',
    defaultMessage: 'Category',
  },
  tags: {
    id: 'publishTemplate.tags',
    defaultMessage: 'Tags',
  },
  tagsPlaceholder: {
    id: 'publishTemplate.tagsPlaceholder',
    defaultMessage: 'e.g. SOAP, intake, follow-up (comma separated)',
  },
  location: {
    id: 'publishTemplate.location',
    defaultMessage: 'Location',
  },
  locationPlaceholder: {
    id: 'publishTemplate.locationPlaceholder',
    defaultMessage: 'Country or region',
  },
  cancel: {
    id: 'global.cancel',
    defaultMessage: 'Cancel',
  },
  categoryNote: {
    id: 'global.note',
    defaultMessage: 'Note',
  },
  categoryDocument: {
    id: 'global.document',
    defaultMessage: 'Document',
  },
  publish: {
    id: 'publishTemplate.publish',
    defaultMessage: 'Publish',
  },
  publishing: {
    id: 'publishTemplate.publishing',
    defaultMessage: 'Publishing...',
  },
  publishSuccess: {
    id: 'publishTemplate.publishSuccess',
    defaultMessage: 'Template published to community',
  },
  publishError: {
    id: 'publishTemplate.publishError',
    defaultMessage: 'Failed to publish template to community',
  },
  republishTitle: {
    id: 'publishTemplate.republishTitle',
    defaultMessage: 'Update community listing',
  },
  republishDescription: {
    id: 'publishTemplate.republishDescription',
    defaultMessage:
      '"{name}" is already in the community catalog. Saving publishes a snapshot of the current version and updates the listing.',
  },
  republish: {
    id: 'publishTemplate.republish',
    defaultMessage: 'Save changes',
  },
  republishSuccess: {
    id: 'publishTemplate.republishSuccess',
    defaultMessage: 'Community listing updated',
  },
});
